import { render, staticRenderFns } from "./CompartilharConta.vue?vue&type=template&id=e3a86b78&scoped=true&"
import script from "./CompartilharConta.vue?vue&type=script&setup=true&lang=js&"
export * from "./CompartilharConta.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a86b78",
  null
  
)

export default component.exports